import { RootState } from '../root.reducers';
import { SnmpDestination, SnmpV3User } from './snmp.types';

export const getSnmpUsers = (state: RootState): SnmpV3User[] =>
  state.snmp.snmpUsers;

export const getSnmpUser = (state: RootState): SnmpV3User | null =>
  state.snmp.singleUser;

export const getSelectedSnmpUser = (state: RootState): SnmpV3User | null => state.snmp.selectedUser;

export const getSnmpDests = (state: RootState): SnmpDestination[] =>
  state.snmp.snmpDests;

export const getSnmpDest = (state: RootState): SnmpDestination | null =>
  state.snmp.singleDest;

export const getSelectedSnmpDest = (state: RootState): SnmpDestination | null => state.snmp.selectedDest;
